import React from "react";
import { Modal } from "react-bootstrap";
import Close from "../../../Helpers/CloseBtn/Close";
import Button from "../../../Helpers/Button/Button";
import { useDeleteCategoryMutation } from "../../../../Redux/service/InventorySetup/InventorySetup";
import { toast } from "react-toastify";

const RegularDelete = ({ id, deleteType, onClose }) => {
	let [deleteCategory] = useDeleteCategoryMutation();

	const Remove = async () => {
		await deleteCategory(id).unwrap();
		toast.success("Category Deleted Successfully", {
			autoClose: 800,
			rtl: localStorage.getItem("lang") === "ar" ? true : false,
		});
		onClose();
	};
	return (
		<Modal show={!!id} centered>
			<Modal.Header>
				<div className="flex-between w-100">
					<Modal.Title>Delete</Modal.Title>
					<Close style="close-32 close" close={() => onClose()} img="Close" />
				</div>
			</Modal.Header>
			<Modal.Body>
				Are you sure you want to delete this {deleteType}?
			</Modal.Body>
			<Modal.Footer>
				<Button
					type={"default"}
					htmlType="button"
					onClick={() => onClose()}
					text="Cancel"
				/>
				<Button
					danger={true}
					type="default"
					text="Delete"
					onClick={() => Remove()}
				/>
			</Modal.Footer>
		</Modal>
	);
};

export default RegularDelete;
